import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ErrCode, LinkPathListApiInput } from '../../shared/models';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FileItemService } from '../file-item.service';
import { DialogReportLinkComponent } from '../../link-consume/dialog-report-link/dialog-report-link.component';
import { LoggerService } from '../../core/logger.service';
import { LinkFileListService } from '../../link-consume/services/link-file-list.service';
import { SyncCookieService } from '../../core/sync-cookie.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'sync-preview-applink',
    templateUrl: './preview-applink.component.html',
})
export class PreviewApplinkComponent implements OnInit, OnDestroy {
    @Input() public type: string; // binding from component.
    public item: sync.IFile;
    public list: sync.IFile[] = [];
    public locId: number;
    public initialized = false;
    public ctx: string;
    public notice = 0;
    public errcode: ErrCode;
    public upsell = false;
    public isPro = 0;
    public isBusiness = 1; // set default 1 so that it's not shown immediately

    //white label attributes
    public isWhiteLabel: boolean;
    public linkTextColor: string;
    public buttonTextColor: string;
    public buttonPrimaryColor: string;

    private subscription: Subscription;

    constructor(
        private modalService: NgbModal,
        private fileItemService: FileItemService,
        private loggerService: LoggerService,
        private linkPathListService: LinkFileListService,
        private syncCookieService: SyncCookieService,
        private route: ActivatedRoute,
        private router: Router
    ) {}

    ngOnInit() {
        this.locId =  this.route.snapshot.params['id'];
        // this.ctx = this.$stateParams.ctx;
        let dispatched = false;

        // const rawKey = this.LinkPathList.sanitizeKey(
        //     (this.$stateParams.key)
        //         ? this.$stateParams.key
        //         : this.$location.hash()
        // );
        if (!this.type) {
            this.type = this.route.snapshot.params['type'];
        }

        const linkPass = this.syncCookieService.getLinkPassword(
            this.route.snapshot.params['cachekey']
        );
        this.initialized = false;

        this.subscription = this.linkPathListService
            .getSubscription()
            .subscribe((data) => {
                try {
                    if (data.error) {
                        if (
                            data.error instanceof ErrCode &&
                            data.error.code == 8018
                        ) {
                            this.loggerService.warn(
                                'Password is missing or expired'
                            );
                            this.router.navigate(['.'], { relativeTo: this.route.parent });
                        } else {
                            // this.errcode = data.error;
                        }
                        this.loggerService.e(
                            'An error was received loading external link preview',
                            data.error
                        );
                    }
                    if (
                        data &&
                        data.pathlist &&
                        data.pathlist.length &&
                        data.loaded &&
                        data.sorted
                    ) {
                        this.list = data.pathlist.filter((val) => {
                            return this.fileItemService.isImage(val);
                        });

                        const item = data.pathlist.filter((value) => {
                            if (value.loc_id == this.route.snapshot.params['id']) {
                                return true;
                            }
                        });
                        if (item.length == 0) {
                            throw new ErrCode(1804);
                        } else if (item.length == 1) {
                            this.item = item[0];
                        } else {
                            throw new ErrCode(
                                1000,
                                'This file listing has an error'
                            );
                        }
                        if (
                            this.type != 'default' &&
                            !this.fileItemService.isPreviewable(this.item)
                        ) {
                            this.type = 'default';
                            this.notice = 1;
                        }
                        this.isPro = data.is_pro;
                        this.isBusiness = data.is_business;
                        this.initialized = true;
                    } else if (!dispatched) {
                        dispatched = true;
                        const input = new LinkPathListApiInput();
                        input.sync_id = this.route.snapshot.queryParams['sync_id'];
                        input.publink_id = this.route.snapshot.params['cachekey'];
                        input.passwordlock = linkPass;
                        console.log('input in preview:', input);
                        this.linkPathListService.dispatchApp(input);
                        this.loggerService.info('Dispatched App');
                    }

                    //get white label attributes
                    if (data.loaded && data.sorted) {
                        if (data.image_cachekey) {
                            this.isWhiteLabel = true;
                            this.linkTextColor = data.link_text_color;
                            this.buttonPrimaryColor = data.button_primary_color;
                            this.buttonTextColor = data.button_text_color;
                        }
                    }
                } catch (ex) {
                    this.loggerService.e('Cannot process applink', ex);
                    // This results in an unknown type and nothing is rendered for errors that occur in this component
                    this.type = 'error';
                    this.errcode = ErrCode.fromException(ex);
                    this.initialized = true;
                }
            });
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    public onStateChange(event: any) {
        this.type = event.type;
        this.upsell = event.upsell;
    }

    public showReportDialog() {
        const ref = this.modalService.open(DialogReportLinkComponent, {
            backdropClass: 'in',
            windowClass: 'in',
            backdrop: 'static',
        });
        ref.componentInstance.linkID = this.route.snapshot.params['cachekey'];
    }
}
